/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import pythonIcon from "./assets/images/python-brands-solid-full.svg";
import djangoIcon from "./assets/images/django.png";
import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Bishal Gharti",
  title: "Hi, I'm Bishal",
  subTitle: emoji(
    "A passionate Backend developer having an experience of building Web applications and backend development with JavaScript / Vue.js / Php / Laravel and some other cool libraries and frameworks."
  ),
  // resumeLink:
  //   "https://drive.google.com/file/d/1hjPrrqlQ3ut4cS-xi65UZ3WO182tI4Gw/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Bishalmag",
  linkedin: "https://www.linkedin.com/in/bishal-magar-799679282/",
  gmail: "ghartimagarbishal87@gmail.com",
  facebook: "https://www.facebook.com/bishalgharti.magar.10",
  instagram: "https://www.instagram.com/bishalghartimagar/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "WEB DEVELOPER, BACKEND DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("Design and consume REST APIs with PHP, Laravel, or Node.js backends"),
    emoji(
      "Use Git and GitHub for version control, collaboration, and project management"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "MySQL-database",
      fontAwesomeClassname: "fas fa-database"
    },
     {
    skillName: "PHP",
    fontAwesomeClassname: "fab fa-php"
  },
  {
    skillName: "Laravel",
    fontAwesomeClassname: "fab fa-laravel" 
  },
  {
    skillName: "RESTful API",
    fontAwesomeClassname: "fas fa-network-wired" // generic icon for APIs
  },
  {
    skillName: "Git",
    fontAwesomeClassname: "fab fa-git-alt"
  },
  {
    skillName: "GitHub",
    fontAwesomeClassname: "fab fa-github"
  },
   {
    skillName: "Linux",
    fontAwesomeClassname: "fab fa-linux"
  },
  {
    skillName: "Python",
    image: pythonIcon
  },
  {
    skillName: "Django",
    image: djangoIcon
  }
  

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "GoldenGate Int'l College",
      logo: require("./assets/images/ggic.jpeg"),
      subHeader: "Bachelor of Computer Application (BCA)",
      duration: "2021 - 2026",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
  role: "Full Stack Internship",
  company: "Tech Solutions Inc.",
  companylogo: require("./assets/images/yaj tech.jpeg"),
  date: "September 8, 2025 – December 8, 2025",
  desc: "Developed and maintained full-stack web applications (Clothing Application), integrating modern front-end frameworks with robust backend APIs, ensuring high performance and scalability.",
  descBullets: [
    "Built dynamic user interfaces using Vue.js 3 and responsive design principles.",
    "Designed and implemented RESTful APIs with PHP and Laravel, connected to MySQL databases.",
    "Managed version control and collaborative workflows using Git and GitHub.",
    "Deployed and maintained applications on Linux servers."
  ]
},
    // {
    //   role: "Front-End Developer",
    //   company: "Quora",
    //   companylogo: require("./assets/images/quoraLogo.png"),
    //   date: "May 2017 – May 2018",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My Projects",
  subtitle: "SOME PROJECTS THAT I CREATED FOR PURSUING MY DEGREE AND CARRER",
  projects: [
    {
      // image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Book Management System",
      projectDesc: "BookMS is a full‑stack PHP & MySQL based web application designed to manage books and support e‑commerce style interactions such as browsing, cart management, checkout, user authentication, rating, and order tracking.At its core, BookMS combines book browsing, user accounts, cart functionality, and payment integration into a single system that simulates a basic online bookstore experience.",
      footerLink: [
        {
          name: "Book Management System",
          url: "https://github.com/Bishalmag/bookms"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/clothingapp .png"),
      projectName: "Clothing App",
      projectDesc: "Vue‑Clothing is a full-stack e-commerce application built using Vue.js for the frontend and PHP + MySQL for the backend. It simulates a complete online clothing store with features like product browsing, shopping cart, checkout, payment, and user management.The project demonstrates both modern frontend techniques with Vue and backend API handling using PHP, making it a solid portfolio project for full-stack development.The project demonstrates both modern frontend techniques with Vue and backend API handling using PHP, making it a solid portfolio project for full-stack development.",
      footerLink: [
        {
          name: "Clothing Application",
          url: "https://github.com/Bishalmag/vue-clothing"
        }
      ]
    },
    {
      image: require("./assets/images/HMS.png"),
      projectName: "Hostel Management System",
      projectDesc: "SMART-HOMS is a data-driven hostel management platform that goes beyond standard CRUD systems by integrating algorithmic optimization into real-world facility operations. Built solo with Django, MySQL, and React.js, the system features role-based access for admins and students, budget-aware procurement optimization via 0/1 Knapsack dynamic programming, shortest-path emergency evacuation routing using Dijkstra's algorithm, and triple exponential smoothing through Holt-Winters for predicting future occupancy trends and peak booking periods.",
      footerLink: [
        {
          name: "Hostel Management System",
          url: "https://github.com/Bishalmag/hostel_management_system"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Letters and Other Stuff that I have received !",

  achievementsCards: [
    {
      title: "Full Stack Internship Certificate",
      subtitle:
        "Gained hands-on experience in full-stack web development, building dynamic applications with Vue.js, PHP/Laravel, and MySQL while collaborating in a real-world software environment.",
      image: require("./assets/images/yaj tech.jpeg"),
      imageAlt: "Certificate",
      // footerLink: [
      //   {
      //     name: "Completion Certificate",
      //     url: "https://drive.google.com/file/d/1UYEww5kXnrvgc_dH0wrV-aNK2qMk_KnL/view?usp=sharing"
      //   }
      //   // {
      //   //   name: "Letter of Recommendation",
      //   //   url: "https://drive.google.com/file/d/1rVbqTz_WjWUQO3oIV52uEnO9nD2vU2sC/view?usp=sharing"
      //   // },
      //   // {
      //   //   name: "Mentor's Recommendation",
      //   //   url: "https://drive.google.com/file/d/1drVYPYuKme0Z2q6d5IhzB47_5yiTrMHq/view?usp=sharing"
      //   // }
      // ]
    },
    // {
    //   title: "Google Assistant Action",
    //   subtitle:
    //     "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
    //   image: require("./assets/images/googleAssistantLogo.webp"),
    //   imageAlt: "Google Assistant Action Logo",
    //   footerLink: [
    //     {
    //       name: "View Google Assistant Action",
    //       url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    // {
    //   url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
    //   title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
    //   description:
    //     "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    // },
    // {
    //   url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
    //   title: "Why REACT is The Best?",
    //   description:
    //     "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE"
  ),

  talks: [
    {
      title: "DM for conversation",
      subtitle: "let's exchange ideas",
      // slides_url: "https://bit.ly/saadpasta-slides",
      connect_url: "https://www.instagram.com/direct/new/?username=bishalghartimagar"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

// const podcastSection = {
//   title: emoji("Podcast 🎙️"),
//   subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

//   // Please Provide with Your Podcast embeded Link
//   podcast: [
//     "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
//   ],
//   display: true // Set false to hide this section, defaults to true
// };

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  resumeLink: "https://drive.google.com/file/d/1hjPrrqlQ3ut4cS-xi65UZ3WO182tI4Gw/view?usp=sharing",
  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+977-9843967328",
  email_address: "ghartimagarbishal87@gmail.com"
};



const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  contactInfo,
  isHireable,
  resumeSection
};
